// WO-29: eBay's API licence asks us to say how old a displayed listing is when it is not live.
// `last_checked` is when we last saw the listing on eBay (ISO with offset, from the API).
export function checkedAgo(lastChecked, now = Date.now()) {
  if (!lastChecked) return null;
  const t = new Date(lastChecked).getTime();
  if (!Number.isFinite(t)) return null;
  const minutes = Math.max(0, Math.round((now - t) / 60000));
  if (minutes < 60) return 'Checked on eBay just now';
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `Checked on eBay ${hours}h ago`;
  const days = Math.round(hours / 24);
  return `Checked on eBay ${days}d ago`;
}

export function checkedTitle(lastChecked) {
  if (!lastChecked) return undefined;
  const d = new Date(lastChecked);
  if (!Number.isFinite(d.getTime())) return undefined;
  return `Last checked on eBay ${d.toLocaleString()}. Price and availability may have changed since; the eBay page is current.`;
}
